import { UtensilsCrossed } from 'lucide-react';
import InventoryMaster from './InventoryMaster';

export default function KitchenMaster({ user }) {
  return (
    <InventoryMaster
      user={user}
      masterType="kitchen"
      apiPrefix="kitchen-master"
      superCategory="Food"
      userRole="kitchen"
      title="Kitchen Master"
      Icon={UtensilsCrossed}
      iconColor="text-orange-600"
      emptyMessage="No approved food items found in Price Master"
    />
  );
}
